import { I_RootState } from './interfaces';
import * as actionTypes from './actionTypes';

const TravelPavilionGroupID = new URLSearchParams(window.location.search).get(
    'TravelPavilionGroupID'
);

const initialState: I_RootState = {
    SearchPrice: {
        data: undefined,
        isLoading: true,
    }, // API載回來的原始資料
    SearchInfoCalendar: {
        data: undefined,
        isLoading: true
    },
    SearchInfoCalendarBar: {
        data: undefined,
        isLoading: true
    },

    // FilterDate:[], // OriginalData 重新拼裝的 篩選用資料
    ShowData: {
        data: undefined,
    }, // 要顯示畫面的資料
    UrlParams: {
        Rtow: 1,
        ClsType: 0,
        Adt: 1,
        Chd: 0,
        Inf: 0,
        NoTrans: false,
        SeekDestinations: [
            {
                DepartAirport: '',
                DepartCity: 'TPE',
                DepartCountry: 'TW',
                ArriveAirport: '',
                ArriveCity: 'LAX',
                ArriveCountry: 'US',
                DepartDate: '2022-03-09',
            },
            {
                DepartAirport: '',
                DepartCity: 'LAX',
                DepartCountry: 'US',
                ArriveAirport: '',
                ArriveCity: 'TPE',
                ArriveCountry: 'TW',
                DepartDate: '2022-03-17',
            },
        ],
        PreferAirlines: '',
    },
    FilterData: undefined,
    SortType: 'price', //目前排序的類別
    MiniRuleInfo: {
        data: undefined,
        isLoading: true,
    },
    FlightFixedRule: {
        data: undefined,
        isLoading: true,
    },
    FareRuleInfo: {
        data: undefined,
        isLoading: true,
    },
    NoticeInfo: undefined,
    SaleInfo: undefined,
};

const reducer = (state: I_RootState = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_SEARCHPRICE:
            return { ...state, SearchPrice: { ...state.SearchPrice, isLoading: true } };
        case actionTypes.SET_SEARCHPRICE_SUCCESS:
            return { ...state, SearchPrice: { data: action.payload, isLoading: false } };
        case actionTypes.SET_SEARCHINFOCALENDAR:
            return { ...state, SearchInfoCalendar: { ...state.SearchInfoCalendar, isLoading: true } };
        case actionTypes.SET_SEARCHINFOCALENDAR_SUCCESS:
            return { ...state, SearchInfoCalendar: { data: action.payload, isLoading: false }, SearchInfoCalendarBar: { data: action.payload, isLoading: false } };
        case actionTypes.SET_SEARCHINFOCALENDAR_BAR:
            return { ...state, SearchInfoCalendarBar: { ...state.SearchInfoCalendarBar, isLoading: true } };
        case actionTypes.SET_SEARCHINFOCALENDAR_BAR_SUCCESS:
            return { ...state, SearchInfoCalendarBar: { data: action.payload, isLoading: false } };
        case actionTypes.SET_URLPARAMS:
            return { ...state, UrlParams: action.payload };
        case actionTypes.SET_FILTERDATA:
            return { ...state, FilterData: action.payload };
        case actionTypes.SET_SHOWDATA:
            return { ...state, ShowData: { data: action.payload } };
        case actionTypes.SET_SORTTYPE:
            return { ...state, SortType: action.payload };
        case actionTypes.SET_MINIRULEINFO:
            return { ...state, MiniRuleInfo: { ...state.MiniRuleInfo, isLoading: true } };
        case actionTypes.SET_MINIRULEINFO_SUCCESS:
            return { ...state, MiniRuleInfo: { data: action.payload, isLoading: false } };
        case actionTypes.SET_FARERULEINFO:
            return { ...state, FareRuleInfo: { ...state.FareRuleInfo, isLoading: true } };
        case actionTypes.SET_FARERULEINFO_SUCCESS:
            return { ...state, FareRuleInfo: { data: action.payload, isLoading: false } };
        case actionTypes.SET_FLIGHTFIXEDRULE:
            return { ...state, FlightFixedRule: { ...state.FlightFixedRule, isLoading: true } };
        case actionTypes.SET_FLIGHTFIXEDRULE_SUCCESS:
            return { ...state, FlightFixedRule: { data: action.payload, isLoading: false } };
        case actionTypes.SET_NOTICEINFO:
            return { ...state, NoticeInfo: action.payload };
        case actionTypes.SET_SALEINFO:
            return { ...state, SaleInfo: action.payload };
        default:
            return state;
    }
};

export default reducer;
